import { render, staticRenderFns } from "./Datamatrix.vue?vue&type=template&id=57ee1720&scoped=true"
import script from "./Datamatrix.vue?vue&type=script&lang=js"
export * from "./Datamatrix.vue?vue&type=script&lang=js"
import style0 from "./Datamatrix.vue?vue&type=style&index=0&id=57ee1720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ee1720",
  null
  
)

export default component.exports